import type { FilterConfig } from '#types/config/components/filter'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    base: 'bg-white rounded-xs',
    selected: 'bg-brand-3 c-white',
    unselected: 'bg-white b-grey-40 c-grey-10'
  }
} satisfies RecursivePartial<FilterConfig['option']['tileExpanded']>
